import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular,
    },
    accordionSummary: {
      background: '#f5f5f5',
      height: 72,
    },
    table: {
      minWidth: 650,
    },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    tableWrapper: {
      marginBottom: 15,
    },
  }),
);
